export default __webpack_public_path__ + "static/media/2612.9116f78c.png";